export default {
  header: {
    title: ['Order a', 'ride', 'with a worldwide platform'],
    subTitle: 'Using streaming mobility platform',
  },
  scrollText: '',
  exoNote:
    'As of June 30, 2am, Taxelco will no longer offer collective transportation service for EXO, to order transportation, call 514-285-5284 or go to exo.quebec/taxicollectif',
  btnLinkText: 'IMPORTANT MESSAGE TO USERS, CLICK HERE',
};
